export const cvTranslations = {
  en: {
    profile: "Profile",
    summary: "Summary",
    educationAcademics: "Education/Academics",
    nationality: "Nationality",
    languages: "Languages",
    nationalityLanguages: "Nationality / Languages",
    professionalCareer: "Professional career",
    projectExperience: "Project experience",
    excerptRelevantProjects: "(Excerpt of relevant projects)",
    industryTechnicalExpertise: "Industry & Technical Expertise",
    continuedSuffix: " — continued",
    continuesOnNextPage: "Continues on next page",
    page: "Page",
    timePeriod: "Time period",
    project: "Project",
    goal: "Goal",
    tasks: "Tasks",
    role: "Role",
    technologies: "Technologies",
    employmentPeriod: "Employment period",
    position: "Position",
    company: "Company",
    industries: "Industries",
    cvNotAvailable: "CV not available",
    requirementsMatch: "Requirements Match for ",
    requirementsMatchOnly: "Requirements Match",
    requirement: "Requirement",
    match: "Match",
    projectExperienceTime: "Project Experience",
    pageReference: "Page Ref.",
    years: "years",
    months: "months",
    year: "year",
    month: "month",
  },
  de: {
    profile: "Profil",
    summary: "Zusammenfassung",
    educationAcademics: "Ausbildung/Akademischer Werdegang",
    nationality: "Nationalität",
    languages: "Sprachen",
    nationalityLanguages: "Nationalität / Sprachen",
    professionalCareer: "Beruflicher Werdegang",
    projectExperience: "Projekterfahrung",
    excerptRelevantProjects: "(Auszug relevanter Projekte)",
    industryTechnicalExpertise: "Branchen- & Technische Expertise",
    continuedSuffix: " — Fortsetzung",
    continuesOnNextPage: "Fortsetzung auf nächster Seite",
    page: "Seite",
    timePeriod: "Zeitraum",
    project: "Projekt",
    goal: "Ziel",
    tasks: "Aufgaben",
    role: "Rolle",
    technologies: "Technologien",
    employmentPeriod: "Beschäftigungszeitraum",
    position: "Position",
    company: "Unternehmen",
    industries: "Branchen",
    cvNotAvailable: "Lebenslauf nicht verfügbar",
    requirementsMatch: "Anforderungsabgleich für ",
    requirementsMatchOnly: "Anforderungsabgleich",
    requirement: "Anforderung",
    match: "Übereinstimmung",
    projectExperienceTime: "Projekterfahrung",
    pageReference: "Seite",
    years: "Jahre",
    months: "Monate",
    year: "Jahr",
    month: "Monat",
  },
};

export type Language = keyof typeof cvTranslations;
